export const getRewardShadowColor = (rarity: number) => {
  if (rarity < 5) {
    return 'rgba(146, 157, 253, 0.24)'
  }

  if (rarity < 10) {
    return '#AC79FF'
  }

  return '#F14BFF'
}
